// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkolb4i{border-radius:var(--ds-radius-xsmall,2px)}._189eidpf{border-width:0}\n._1bsb1tcg{width:24px}\n._1o9zidpf{flex-shrink:0}\n._4t3i1tcg{height:24px}\n._bfhk1j28{background-color:transparent}", ""]);
// Exports
module.exports = exports;
